import { Box, Flex } from "@chakra-ui/react";

const StepIndicator = ({
  currentStep = 0,
  step = 3,
}: {
  currentStep?: number;
  step?: number;
}) => {
  return (
    <Flex
      gap={"8px"}
      sx={{
        height: "20px",
      }}
      alignItems={"center"}
    >
      {Array.from({ length: step }).map((_, index) => (
        <Box
          key={index}
          sx={{
            background: index === currentStep ? "#D8762B" : "#D9D9D9",
            width: index === currentStep ? "40px" : "20px",
            height: "4px",
            borderRadius: "100px",
            transition: "all 0.3s ease",
          }}
        ></Box>
      ))}
    </Flex>
  );
};

export default StepIndicator;
